module.exports = __webpack_public_path__ + "img/scheduled-action-icon.c9f7c22e.svg";